import * as _ from 'lodash'
import { Variable, VString, VBoolean, VNumber, VSet, VArray } from 'alkali'
import { andValidation, notEmptyFn, notEmptyArrayFn, notEmpty, orValidation, validationCtx, validateFn, validPositiveInteger } from './validation'
import { validStudyN } from './extraction'
import { str } from 'services/extract/util'
export { AbstractSource } from 'services/extract/types'

export const validYear = validateFn(s =>
	(s = str(s)) && validPositiveInteger(s) && !s.includes('.') &&
	_.inRange(Number(s), 1900, new Date().getFullYear() + 2), 'Must be whole number within 1900 and ' + (new Date().getFullYear() + 1)
)

const validDesigns = validationCtx('Designs', notEmptyArrayFn)
const validAbstractDesigns = validationCtx('Abstract', validateFn(abs =>
	validDesigns(abs?.Designs).isValid)
)

const abstractSourceValidation = andValidation(
	validationCtx('Title', notEmptyFn),
	validationCtx('Publication Year', validYear),
	validationCtx('Acronym & Authors', validateFn(([ac,au]) => notEmpty(ac) || notEmpty(au), 'Acronym or Authors must not be empty')),
	validDesigns,
	validStudyN
)
const validAbstractSource = validationCtx('Abstract', validateFn(abs =>
	abstractSourceValidation([abs.Title, abs.PublicationYear, [abs.Acronym, abs.Authors], abs.Designs, abs.N, abs.Abstract]).isValid
))

/**
 * Reactive Variable Class around the Study/Abstract Metadata, wheether sourced from DD or DS
 */
export default class VAbstractSource extends Variable.with({
	Title: VString,
	Source: VString,
	Private: VBoolean,
	Permit: VString,
	PublicationYear: VNumber,
	Authors: VString,
	Acronym: VString,
	DOI: VString,
	FullTextURL: VString,
	Designs: VArray,
	AbstractSentences: VArray,
	Abstract: VString,
	N: VString,
	validate: a => andValidation(validAbstractDesigns, validStudyN)([a.valueOf(), a.valueOf()?.N])
}) {
	constructor(props = { Designs: [], Private: true, Permit: undefined }) {
		super(props)
	}
}

export class VUploadAbstractSource extends VAbstractSource.with({
	validate: a => validAbstractSource(a.valueOf())
}) {
	static create(user) {
		return new VUploadAbstractSource({ Designs: [], Private: true, Permit: 'client:' + user.Client.Id })
	}
}
